import "./styles/globals.css";
import { initRouter } from "./router.js";

const root = document.getElementById("app");
initRouter(root);
